import React, { useEffect, useState } from 'react'
import useAuth from '../../../context/auth/useAuth'
import { Button, Col, Form, FormSelect, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getUser } from '../../../actions/profiles/usersActions'
import Loader from '../../../components/design/Loader/Loader'
import MemberSelect from '../../../components/design/Select/MemberSelect'
import { getClient } from '../../../actions/profiles/clientsActions'
import { getGroupsPublicByActivityAndClient } from '../../../actions/activities/groupsActions'
import { addCartItem } from '../../../actions/payments/cartActions'
import Swal from 'sweetalert2'

export default function Group({activity, club}) {
	const {clientauth} = useAuth()
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const {user, loading} = useSelector(state=>state.users)
    const {client, loading: clientLoading} = useSelector(state => state.clients)
    const {groupsMarket: groups, loadinggroup: groupsLoading, commission} = useSelector(state => state.groups)
    const {status} = useSelector(state => state.cart)

    const [clientSelected, setClientSelected] = useState(null)
    const [groupOptionsForm, setGroupOptionsForm] = useState([])

    const [groupScheduleModal, setGroupScheduleModal] = useState(null)

    const handleSubmit = (event) => {
        event.preventDefault()
    }

    const handleClientSelect = (value) => {
        setClientSelected(value)
        dispatch(getGroupsPublicByActivityAndClient(activity._id, value._id))
    }

    const handleHoraryChange = (target, index) => {
        setGroupOptionsForm(groupOptionsForm.map((group, i) => {
            if (index === i) {
                return {...group, horarySelected: target.value}
            } else {
                return group
            }
        }))
    }

    const handleQuestionChange = (target, groupIndex, questionIndex) => {
        setGroupOptionsForm(groupOptionsForm.map((group, i) => {
            if (groupIndex === i) {
                return {...group, questions: group.questions.map((question, ind) => {
                    if (questionIndex === ind) {
                        return target.value
                    } else {
                        return question
                    }
                })}
            } else {
                return group
            }
        }))
    }

    const handleGroupSelection = (groupIndex) => {
        if (groups[groupIndex].horaries?.length > 0) {
            let questions = []
            for (let i = 0; i < groups[groupIndex].questions.length; i++) {
                const formQuestion = groupOptionsForm[groupIndex].questions[i]
                if (formQuestion !== '') {
                    questions.push({
                        question: groups[groupIndex].questions[i].question,
                        answer: groups[groupIndex].questions[i].answers.find(a => a._id === formQuestion).option,
                        impact: groups[groupIndex].questions[i].answers.find(a => a._id === formQuestion).impact
                    })
                }
            }

            // Almacenamos las plazas disponibles
            let totalGapsAvailables = 0;
            let firstWithGapsAvailables = -1;

            // Iterar sobre los horarios para calcular las plazas disponibles
            for (let i = 0; i < groups[groupIndex].horaries.length; i++) {
                const gapsAvailables = groups[groupIndex].horaries[i].gaps - groups[groupIndex].horaries[i].occupiedGaps;
                totalGapsAvailables += gapsAvailables;

                // Si aún no se ha encontrado un horario con plazas disponibles, asignarlo
                if (firstWithGapsAvailables === -1 && gapsAvailables > 0) {
                    firstWithGapsAvailables = i;
                }
            }

            // ¿Horario seleccionable?
            if(groups[groupIndex].assignableHorary){
                // ¿Hay plazas en la seleccionada?
                const horaryIdSelected = groupOptionsForm[groupIndex].horarySelected
                const selectedHorary = groups[groupIndex].horaries.find(horary => horary._id === horaryIdSelected)
                if (selectedHorary && (selectedHorary.gaps > selectedHorary.occupiedGaps)) {
                    dispatch(addCartItem({
                        activity: activity,
                        client: clientSelected,
                        paymentClient: clientauth?.client,
                        group: groups[groupIndex],
                        horary: groupOptionsForm[groupIndex].horarySelected,
                        questions: questions,
                        commission: commission.activities,
                        club: club
                    }))
                }else{
                    // No hay disponible en este horario, ¿quieres entrar en lista de espera para este horario?
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: true,
                        confirmButtonText: t('global.accept'),
                        denyButtonText: t('global.cancel'),
                        icon: 'warning',
                        text: t('cart.nogapswantwaitinglist')
                    }).then(result => {
                        // ¿Quiere entrar en lista de espera?
                        if (result.isConfirmed){
                            dispatch(addCartItem({
                                activity: activity,
                                client: clientSelected,
                                paymentClient: clientauth?.client,
                                group: groups[groupIndex],
                                horary: groupOptionsForm[groupIndex].horarySelected,
                                questions: questions,
                                commission: commission.activities,
                                club: club,
                                waitinglist: true
                            }))
                        }else{
                            Swal.fire({
                                icon: 'error',
                                text: t('cart.nogapsavailables'),
                                showConfirmButton: true,
                                confirmButtonText: t('global.accept'),
                                timer: 2000
                            })
                        }
                    })
                }
            }else{
                // ¿Hay plazas?
                if(totalGapsAvailables > 0){
                    // Se añade al carrito
                    dispatch(addCartItem({
                        activity: activity,
                        client: clientSelected,
                        paymentClient: clientauth?.client,
                        group: groups[groupIndex],
                        horary: groups[groupIndex].horaries[firstWithGapsAvailables]._id,
                        questions: questions,
                        commission: commission.activities,
                        club: club
                    }))
                }else{
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: true,
                        confirmButtonText: t('global.accept'),
                        denyButtonText: t('global.cancel'),
                        icon: 'warning',
                        text: t('cart.wantwaitinglist')
                    }).then(result => {
                        // ¿Quiere entrar en lista de espera?
                        if (result.isConfirmed) {
                            dispatch(addCartItem({
                                activity: activity,
                                client: clientSelected,
                                paymentClient: clientauth?.client,
                                group: groups[groupIndex],
                                horary: groups[groupIndex].horaries[(groups[groupIndex].horaries?.length-1)]._id,
                                questions: questions,
                                commission: commission.activities,
                                club: club,
                                waitinglist: true
                            }))
                        }else{
                            Swal.fire({
                                icon: 'error',
                                text: t('cart.nogapsavailables'),
                                showConfirmButton: true,
                                confirmButtonText: t('global.accept'),
                                timer: 2000
                            })
                        }
                    })
                }
            }
        } else {
            Swal.fire({
                icon: 'error',
                text: t('cart.noHorariesAvailable'),
                showConfirmButton: true,
                confirmButtonText: t('global.accept'),
                timer: 2000
            })
        }
    }

    const calculatePrice = (group, formGroup) => {
        // Si no hay preguntas o no se han respondido las preguntas
        if (formGroup?.questions && (formGroup.questions.length === 0 || formGroup?.questions?.every(question => question.trim() === ""))) {
            let priceToPay = parseFloat(group?.registrationPayment?.price || 0) + parseFloat(group.seasonPayments.reduce((acumulator, seasonPayDate) => {
                const currentDate = new Date()
                const endDate = new Date(seasonPayDate.endDate)

                if (currentDate < endDate) {
                    return parseFloat(acumulator) + (parseFloat(seasonPayDate.price) || 0)
                } else {
                    return parseFloat(acumulator)
                }
            }, 0))
            let priceComission = commission?.activities?.find(activity => priceToPay >= activity.lowPrice && priceToPay <= activity.highPrice);

            if (priceToPay <= 0) {
                return 0.00
            } else {
                return (Math.ceil((parseFloat(priceToPay) + parseFloat(priceToPay * (priceComission?.percentage || 0) / 100) + parseFloat(priceComission?.double || 0)) * 100) / 100).toFixed(2)
            }

        } else {
            let registrationPayment = 0
            if (group.registrationPayment?.maxdate && new Date(group.registrationPayment?.maxdate) >= new Date()) {
                registrationPayment = parseFloat(group.registrationPayment.price)
            }
            const registrationImpact = (formGroup?.questions || [])
            .filter(question => question.trim() !== "")
            .reduce((sum, question) => {
                const selectedAnswer = group?.questions.find(q => !!q.answers?.find(a => a._id === question))?.answers?.find(a => a._id === question)
                const registrationPercentageTotal = (parseFloat(registrationPayment) * ((parseFloat(selectedAnswer?.impact?.registrationPercentage || 0)) / 100))

                return parseFloat(sum) + (parseFloat(registrationPercentageTotal)) + (selectedAnswer?.impact?.registrationQuantity || 0);
            }, 0)

            const seasonPaymentsTotal = group.seasonPayments.reduce((seasonPaymentTotal, seasonPayment) => {
                if (new Date(seasonPayment.endDate) > new Date()) {
                    const seasonPaymentImpact = (formGroup?.questions || [])
                    .filter(question => question.trim() !== "")
                    .reduce((questionTotal, question) => {
                        const selectedAnswer = group?.questions.find(q => !!q.answers?.find(a => a._id === question))?.answers?.find(a => a._id === question)
                        const seasonPaymentPercentageTotal = (parseFloat(seasonPayment.price) * ((parseFloat(selectedAnswer?.impact?.seasonPaymentPercentage || 0)) / 100))
        
                        return parseFloat(questionTotal) + (parseFloat(seasonPaymentPercentageTotal)) + (selectedAnswer?.impact?.seasonPaymentQuantity || 0);
                    }, 0)
                    return parseFloat(seasonPaymentTotal) + parseFloat(seasonPaymentImpact) + parseFloat(seasonPayment.price)
                } else {
                    return seasonPaymentTotal
                }
            }, 0)

            const priceToPay = parseFloat(registrationPayment) + parseFloat(registrationImpact) + parseFloat(seasonPaymentsTotal)

            const priceComission = commission?.activities?.find(activity => priceToPay >= activity.lowPrice && priceToPay <= activity.highPrice);

            if (priceToPay <= 0) {
                return 0.00
            } else {
                return (Math.ceil((parseFloat(priceToPay) + parseFloat(priceToPay * (priceComission?.percentage || 0) / 100) + parseFloat(priceComission?.double || 0)) * 100) / 100).toFixed(2)
            }
        }
    }

    const formatSchedule = (schedule) => {
        let scheduleFormatted = []
        if (schedule) {
            for (const section of schedule) {
                if (section.startHour && section.endHour) {
                    for (const day of section.weekDays) {
                        if (day !== 'all') {
                            if (scheduleFormatted[day]) {
                                scheduleFormatted.find(d => d.day === day).hours.push({startHour: section.startHour, endHour: section.endHour})
                            } else {
                                scheduleFormatted.push({day: day, hours: [{startHour: section.startHour, endHour: section.endHour}]})
                            }
                        }
                    }
                }
            }
        }
        return scheduleFormatted
    }

    useEffect(() => {
        dispatch(getUser(clientauth?.id))
        dispatch(getClient(clientauth?.client))
    }, [clientauth, dispatch])

    useEffect(() => {
        if (groups) {            
            setGroupOptionsForm(groups.map(group => {
                return {
                    horarySelected: group.horaries[0]?._id,
                    questions: group.questions.map(question => {
                        if (question.required) {
                            return question.answers[0]?._id
                        } else {
                            return ''
                        }
                    })
                }
            }))
        }
    }, [groups])

    useEffect(() => {
        if (status === 'addSuccess') {
            Swal.fire({
                icon: 'success',
                text: t('cart.' + status),
                showConfirmButton: false,
                timer: 1200
            })
        }
    }, [status, dispatch, t])

    return (
        <>
            {
                loading || clientLoading
                    ?
                        <Loader/>
                    :
                        <div>
                            <Form onSubmit={handleSubmit}>
                                <div className='group-enroll-section'>
                                    <h2>{t('activities.group')}</h2>
                                    <p className='group-enroll-text'>
                                        {t("activities.groupText1")}{club.name}{t("activities.groupText2")}
                                    </p>
                                    <p className='group-enroll-text'>
                                        {t("activities.groupText3")}<span className='fw-bold'>{club.phone}</span>.
                                    </p>
                                        {
                                            !clientauth || clientauth?.usertype === 'club'
                                                ?
                                                    clientauth?.usertype === 'club' ?
                                                        <div className='empty-state-card'>
                                                            <h4>{t('marketplace.registerOrLogIn')}</h4>
                                                            <p>{t('marketplace.activity.needAccount')}</p>
                                                        </div>
                                                    :
                                                        <div className='empty-state-card'>
                                                            <h4>{t('marketplace.registerOrLogIn')}</h4>
                                                            <p>{t('marketplace.activity.needAccount')}</p>
                                                            <div className='empty-state-actions'>
                                                                <Link to={`/${t("url.auth.registerclient")}`} className='btn btn-primary'>
                                                                    {t('signin.register')}
                                                                </Link>
                                                                <Link to={`/${t("url.auth.login")}`} className='btn btn-default'>
                                                                    {t('signin.login')}
                                                                </Link>
                                                            </div>
                                                        </div>
                                                :
                                                    <>
                                                        <div className='mt-4'>
                                                            <Row>
                                                                <Col>
                                                                    {/* <Form.Group> */}
                                                                        {/* <Form.Label>{t('marketplace.activity.member')}</Form.Label> */}
                                                                        <MemberSelect members={user?.members && client ? [...user?.members, client] : null} value={clientSelected} onChange={handleClientSelect}/>
                                                                    {/* </Form.Group> */}
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        {
                                                            clientSelected &&
                                                                <div className='mt-4'>
                                                                    <h6 className='section-subtitle'>{t('marketplace.activity.enrolledClientData')}:</h6>
                                                                    <div className='client-data-card'>
                                                                        <div className='client-data-row'>
                                                                            <span className='client-data-label'>{t("users.firstname")}</span>
                                                                            <span className='client-data-value'>{clientSelected.firstname}</span>
                                                                        </div>
                                                                        <div className='client-data-row'>
                                                                            <span className='client-data-label'>{t("users.lastname")}</span>
                                                                            <span className='client-data-value'>{clientSelected.lastname}</span>
                                                                        </div>
                                                                        <div className='client-data-row'>
                                                                            <span className='client-data-label'>{t("users.birthdate")}</span>
                                                                            <span className='client-data-value'>{clientSelected.birthdate ? `${clientSelected.birthdate.getDate() > 9 ? clientSelected.birthdate.getDate() : "0" + clientSelected.birthdate.getDate()}/${clientSelected.birthdate.getMonth() > 8 ? parseInt(clientSelected.birthdate.getMonth()) + 1 : "0" + (parseInt(clientSelected.birthdate.getMonth()) + 1)}/${clientSelected.birthdate.getFullYear() > 9 ? clientSelected.birthdate.getFullYear() : "0" + clientSelected.birthdate.getFullYear()}` : '-'}</span>
                                                                        </div>
                                                                        <div className='client-data-row'>
                                                                            <span className='client-data-label'>{t("users.gender")}</span>
                                                                            <span className='client-data-value'>{clientSelected.gender ? t("users.gendertype." + clientSelected.gender) : '-'}</span>
                                                                        </div>
                                                                        {
                                                                            clientSelected.tutor1Name &&
                                                                            <>
                                                                                <div className='client-data-row'>
                                                                                    <span className='client-data-label'>{t("users.tutor1Name")}</span>
                                                                                    <span className='client-data-value'>{clientSelected.tutor1Name}</span>
                                                                                </div>
                                                                                <div className='client-data-row'>
                                                                                    <span className='client-data-label'>{t("users.tutor1Phone")}</span>
                                                                                    <span className='client-data-value'>{clientSelected.tutor1Phone}</span>
                                                                                </div>
                                                                                <div className='client-data-row'>
                                                                                    <span className='client-data-label'>{t("users.tutor1Email")}</span>
                                                                                    <span className='client-data-value'>{clientSelected.tutor1Email}</span>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                        {
                                                                            clientSelected.tutor2Name &&
                                                                            <>
                                                                                <div className='client-data-row'>
                                                                                    <span className='client-data-label'>{t("users.tutor2Name")}</span>
                                                                                    <span className='client-data-value'>{clientSelected.tutor2Name}</span>
                                                                                </div>
                                                                                <div className='client-data-row'>
                                                                                    <span className='client-data-label'>{t("users.tutor2Phone")}</span>
                                                                                    <span className='client-data-value'>{clientSelected.tutor2Phone}</span>
                                                                                </div>
                                                                                <div className='client-data-row'>
                                                                                    <span className='client-data-label'>{t("users.tutor2Email")}</span>
                                                                                    <span className='client-data-value'>{clientSelected.tutor2Email}</span>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                     </div>
                                                          }
                                                     </>
                                         }
                                     </div>
                                
                                {
                                    groupsLoading &&
                                        <Loader/>
                                }
                                {
                                    clientSelected && groups?.map((group, index) => (
                                        <div key={index} className='group-enroll-card'>
                                            <div className='group-enroll-header'>
                                                <div>
                                                    <h3>{group.title}</h3>
                                                </div>
                                                <div className='group-enroll-price'>
                                                    {calculatePrice(group, groupOptionsForm[index])}€
                                                </div>
                                            </div>

                                            <div className='group-enroll-rows'>
                                                <div className='group-enroll-row'>
                                                    <span className='group-enroll-label'>{t("marketplace.activity.category")}</span>
                                                    <span className='group-enroll-value'>{group.category.title}</span>
                                                </div>
                                                <div className='group-enroll-row'>
                                                    <span className='group-enroll-label'>{t("marketplace.activity.federated")}</span>
                                                    <span className='group-enroll-value'>
                                                        <span className={`group-detail-badge ${group.federated ? 'active' : ''}`}>
                                                            {group.federated ? t('global.yes') : t('global.no')}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className='group-enroll-row'>
                                                    <span className='group-enroll-label'>{t("marketplace.schedule")}</span>
                                                    <span className='group-enroll-value'>
                                                        <img className='show-schedule' src='/images/eyeopen.svg' alt={t("marketplace.schedule")} onClick={() => setGroupScheduleModal(`${index}`)}/>
                                                    </span>
                                                </div>
                                                <div className='group-enroll-row'>
                                                    <span className='group-enroll-label'>{t("marketplace.activity.age")}</span>
                                                    <span className='group-enroll-value'>{group.category.ageFrom} - {group.category.ageTo} {t('marketplace.activity.yearsOld')}</span>
                                                </div>
                                                {
                                                    group.assignableHorary && group.horaries?.length > 0 &&
                                                        <div className='group-enroll-row'>
                                                            <span className='group-enroll-label'>{t("marketplace.activity.horary")}</span>
                                                            <span className='group-enroll-value'>
                                                                <FormSelect className='group-select' value={groupOptionsForm[index]?.horarySelected} onChange={({target}) => handleHoraryChange(target, index)}>
                                                                    {group.horaries?.map((horary, index) => (
                                                                        <option key={index} value={horary._id}>{horary.name}</option>
                                                                    ))}
                                                                </FormSelect>
                                                            </span>
                                                        </div>
                                                }
                                                {
                                                    group.questions?.map((question, questionIndex) => (
                                                        <div className='group-enroll-row' key={questionIndex}>
                                                            <span className='group-enroll-label'>{question.question}</span>
                                                            <span className='group-enroll-value'>
                                                                <FormSelect className='group-select' required={question.required} value={groupOptionsForm[index]?.questions[questionIndex] || ''} onChange={({target}) => handleQuestionChange(target, index, questionIndex)}>
                                                                    {
                                                                        !question.required &&
                                                                            <option value=''></option>
                                                                    }
                                                                    {question.answers?.map((answer, index) => (
                                                                        <option key={index} value={answer._id}>{answer.option}</option>
                                                                    ))}
                                                                </FormSelect>
                                                            </span>
                                                        </div>
                                                    ))
                                                }
                                            </div>

                                            <div className='group-enroll-action'>
                                                <Button variant='primary' className='btn-enroll' onClick={() => {handleGroupSelection(index)}}>
                                                    {t('marketplace.activity.addGroup')}
                                                    <i className="fas fa-arrow-right ms-2"></i>
                                                </Button>
                                            </div>
                                        </div>
                                    ))
                                }
                            </Form>
                        </div>
            }
            {
                groups &&
                    <Modal show={groupScheduleModal ? true : false} onHide={() => setGroupScheduleModal(null)} size='lg' centered className='modal-rounded'>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                { groups[groupScheduleModal]?.title }
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {
                                groups[groupScheduleModal]?.assignableHorary
                                    ?
                                        <div>
                                            {
                                                formatSchedule(groups[groupScheduleModal]?.horaries?.find(g => g._id === groupOptionsForm[groupScheduleModal]?.horarySelected)?.schedule)?.map((day, index) => (
                                                    <div key={index} className='schedule-row'>
                                                        <div className='schedule-day'>{t('schedule.' + day.day)}</div>
                                                        <div className='schedule-hours'>
                                                            {
                                                                day.hours.map((hour, hourIndex) => (
                                                                    <span key={hourIndex} className='schedule-hour-badge'>
                                                                        { `${hour.startHour} - ${hour.endHour}` }
                                                                    </span>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    :
                                        <div className='text-center py-4 text-muted'>{t('global.undefined')}</div>
                            }
                        </Modal.Body>
                    </Modal>
            }
        </>
    )
}